import { makeStyles, type StyleRules } from '~/utils/withStyles';

const useStyles = makeStyles(({ palette, spacing }) => ({
  description: {
    marginTop: spacing(1),
  },
  formLabel: {
    '& span:nth-child(2)': {
      flex: 1,
      width: '100%',
    },
    alignItems: 'flex-start',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
    margin: '0',
    padding: spacing(2),
  },
  radioButton: {
    marginBottom: spacing(2),
    padding: 0,
  },
  radioButtonChecked: {
    color: `${palette.primary.main} !important`,
  },
  template: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
    height: '100%',
  },
  templateImage: {
    aspectRatio: '16/9',
    height: '300px',
    maxHeight: '300px',
    objectFit: 'cover',
    objectPosition: 'top',
    width: '100%',
  },
  viewTemplateLink: {
    alignSelf: 'center',
    color: 'inherit !important',
    textDecoration: 'underline !important',
  },

} as const satisfies StyleRules));

export default useStyles;
